import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Departement } from 'src/app/shared/models/departement';
import { Region } from 'src/app/shared/models/region';

@Component({
	selector: 'app-region-modal-detail',
	templateUrl: './region-modal-detail.component.html',
	styleUrls: ['./region-modal-detail.component.scss']
})
export class RegionModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
		]),
		sigle: new FormControl('', [
			Validators.required
		])
	});

	listDepartement: Departement[];
	listSelectedDepartement: Departement[];
	region: Region;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.region ? this.region.name : null,
			sigle: this.region ? this.region.sigle : null
		});

		this.facade.departementService.getAllDepartement().subscribe({
			next: (val) => {
				this.listDepartement = val;
			}
		});

		this.listSelectedDepartement = [...this.region.departements];
	}

	isDepartementCheck(dep: Departement): boolean {
		return this.listSelectedDepartement?.some(
			(specItfc) => specItfc.id === dep.id
		);
	}

	updateSelectedDepartement(e: any, dep: Departement) {
		if (e.target.checked) {
			if (!this.listSelectedDepartement.some((z) => z.id === dep.id)) {
				this.listSelectedDepartement.push(dep);
			}
		} else {
			if (this.listSelectedDepartement.some((z) => z.id === dep.id)) {
				this.listSelectedDepartement = this.listSelectedDepartement.filter(
					(z) => z.id !== dep.id
				);
			}
		}
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.region.name = this.formEdit.get('name').value;
		this.region.sigle = this.formEdit.get('sigle').value;
		this.region.departements = this.listSelectedDepartement;
		this.facade.regionService.updateRegion(this.region).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.regionService
			.deleteRegion(this.region.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.regionService
			.deleteRegion(this.region.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
	get sigle() {
		return this.formEdit.get('sigle');
	}
}
